/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Footer/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DoneAction from './DoneAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Footer({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Footer",
  onClose
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Footer.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-2-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-6-2unNA3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-7-2unNA3': dtColorsWhite,'--btc-8-2unNA3': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<DoneAction
  viewPath={`${viewPath}/DoneAction`}
 onClick={onClose}
/>
</div>
{children}
</React.Fragment>)
}